import { createExtendedContainer } from 'configuration/inversify/container/extended';
import { wccModules } from 'enums/wccModules';
import { ObservableArray } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';
import WCCContentContext, { WCCContentContextConfig } from './context';
import WCCContentDocument from './document';
import { WCCContentHelpers } from './helpers';
import { IWCCContentParser } from './parser.interfaces';
import WCCContentRule from './rules/base';

export default class WCCContentParser implements IWCCContentParser {
    private storage: IWCCStorageManager
    private rules: ObservableArray<WCCContentRule>

    dispose: Action

    constructor(rules: Array<WCCContentRule>) {
        const [container, disposeContainer] = createExtendedContainer();
        this.storage = container.get<IWCCStorageManager>(wccModules.storage);
        this.dispose = disposeContainer;

        this.rules = ko.observableArray(rules);
    }

    parse(content: string, contextConfig?: WCCContentContextConfig): WCCContentDocument {
        const nodes = ko.utils.parseHtmlFragment(content);
        const blocks = nodes.map(node => WCCContentHelpers.getBlockFromNode(node));

        const result = this.rules()
            .filter(rule => !rule.disabled())
            .reduce((document, rule) => rule.parse(document, new WCCContentContext(this.storage, contextConfig)), new WCCContentDocument(blocks));

        result.optimize();

        return result;
    }
}